import { CountryInterface } from '@elearning-platform/api-types/interfaces';
import { stringify } from 'query-string';

import { api } from '../api';

export const getCitizenshipCountries: (query: string) => Promise<CountryInterface[]> = (
  query: string
): Promise<CountryInterface[]> => api.get(
  `countries/countries?${stringify({ query }, { skipEmptyString: true })}`
);
